module.exports = __webpack_public_path__ + "assets/logo.b714a370acb384db84f22b9100a3ef8a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/logo.png
 ** module id = 227
 ** module chunks = 0
 **/